import { render, staticRenderFns } from "./symbols.vue?vue&type=template&id=7ed0ed76&scoped=true"
import script from "./symbols.vue?vue&type=script&lang=js"
export * from "./symbols.vue?vue&type=script&lang=js"
import style0 from "./symbols.vue?vue&type=style&index=0&id=7ed0ed76&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed0ed76",
  null
  
)

export default component.exports